import * as yup from "yup";

export interface EmploymentExperienceForm {
  employeeId?: number
  payrollCompanyId: number;
  businessProcessId: number;
  experience?: number;
  lastOrganisation?: string;
  referenceId: number;
  referredBy?: string;
  managerId: number;
  teamLeadId: number;
  managerName?: string;
  teamLeadName?: string;
}

export interface EmploymentExperienceProps {
  nextStep: () => void;
  prevStep: () => void;
  employment: EmploymentExperienceForm;
  setEmployment: React.Dispatch<React.SetStateAction<EmploymentExperienceForm>>;
  employeeId: number | null;
  usCompanyId: number | null;
}

export interface PayrollOption {
  id: number;
  payroll_Company_Name: string;
}

export interface IBusinessProcess {
  business_Process_Id: number;
  business_Process_Name: string;
}

export const schema = yup.object().shape({
  payrollCompanyId: yup.number().typeError("Payroll Company is required").required("Payroll Company is required").min(1, "Payroll Company is required"),
  businessProcessId: yup.number().typeError("Business Process is required").required("Business Process is required").min(1, "Business Process is required"),
  // experience: yup.number().typeError("Experience is required").min(0,),
  // lastOrganisation: yup.string().required("Last Organisation is required"),
  referenceId: yup.number().typeError("Reference ID is required").required("Reference ID is required"),
  managerId: yup.number().typeError("Manager is required").required("Manager is required"),
  teamLeadId: yup.number().typeError("Team Lead is required").required("Team Lead is required"),
});



